import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Box } from '@material-ui/core';

import BaseBox from '../_Common/BaseBox';
import {
  BodyBox,
  RowBox,
  ValueBox,
  TextWin,
  TextLoss,
} from '../_Common/CommonComponents';
import NoData from '../_Common/NoData';
import CustomCircularProgress from '../_Common/CustomCircularProgress';
import { useStyles } from './PerformanceByTagStyles';
import { ApplicationState } from '../../../../../store';
import { TagPerformance } from '../../../../../store/modules/boxes/types';
import { formatPrice, setPriceColor, setPercentColor } from '../../../../../utils/functions';

export default function PerformanceByTag() {
  const classes = useStyles();
  const { loading, boxes } = useSelector(
    (state: ApplicationState) => state.boxes
  );

  const data: TagPerformance[] = boxes.PerformanceByTag || [];
  const hasData = data.length > 0;

  return (
    <BaseBox title="Performance por Tag">
      {!(loading && !hasData) && hasData && (
        <BodyBox>
          <Box>
            <RowBox>
              <TextWin className={classes.titles} variant="body2">
                win
              </TextWin>
              <TextLoss className={classes.titles} variant="body2">
                loss
              </TextLoss>
              <Typography className={classes.titles} variant="body2" style={{ width: '80px' }}>
                Resultado
              </Typography>
              <Typography className={classes.titles} variant="body2">
                %
              </Typography>
            </RowBox>
            {data.map(item => (
              <RowBox key={item.tag}>
                <Box className={classes.tagName}>{item.tag}</Box>
                <ValueBox>
                  <Typography variant="body2">{item.winCount}</Typography>
                </ValueBox>
                <ValueBox>
                  <Typography variant="body2">{item.lossCount}</Typography>
                </ValueBox>
                <ValueBox style={{ width: '80px' }}>
                  <Typography
                    style={{ color: setPriceColor(item.totalPnL), fontSize: '12px' }}
                    variant="body2"
                  >
                    {formatPrice(item.totalPnL)}
                  </Typography>
                </ValueBox>
                <ValueBox>
                  <Typography
                    style={{ color: setPercentColor(item.winRate) }}
                    variant="body2"
                  >
                    {item.winRate}%
                  </Typography>
                </ValueBox>
              </RowBox>
            ))}
          </Box>
        </BodyBox>
      )}
      {loading && !hasData && <CustomCircularProgress />}
      {!loading && !hasData && <NoData />}
    </BaseBox>
  );
}
